import { ProjectChangeControlApiModel } from '@/core/models/api/project-change-control.model';
import { ApuCategoryApiModel } from '@/core/models/api/apu-category-api.model';
import { ApuFieldContext } from '@/shared/constants/apu-field-context';

export type ChangeControlActionContext = 'addResources' | 'editResource' | 'deleteResource' | 'generic';

export interface ProjectChangeControlState {
  /** All change control requests for the current project */
  changeRequests: ProjectChangeControlApiModel[];
  /** The partially built request waiting for user to complete the form */
  pendingRequest: Partial<ProjectChangeControlApiModel> | null;
  /** The APU category affected by the pending change */
  pendingApuCategory: ApuCategoryApiModel | null;
  /** Context of what action triggered the dialog */
  pendingActionContext: ChangeControlActionContext | null;
  /** Whether the change-control request dialog is open */
  isDialogOpen: boolean;
  loading: boolean;
  submitting: boolean;
  /** The last successfully submitted request — components watch this to proceed */
  lastSubmittedRequest: ProjectChangeControlApiModel | null;
  error: string | null;
  /** Categories that have been modified during the current change control workflow */
  changedCategories: ApuCategoryApiModel[];
  /** Active field context for the change control workflow */
  activeFieldContext: ApuFieldContext;
}

export const initialProjectChangeControlState: ProjectChangeControlState = {
  changeRequests: [],
  pendingRequest: null,
  pendingApuCategory: null,
  pendingActionContext: null,
  isDialogOpen: false,
  loading: false,
  submitting: false,
  lastSubmittedRequest: null,
  error: null,
  changedCategories: [],
  activeFieldContext: 'meta',
};
